export enum EBuildingLiftType {
  Service = 1,
  Telpher = 2,
  Passenger = 3,
}
